import { z } from 'zod';

export const fieldCropzoneSchema = z.object({
  id: z.string(),
  field_id: z.string(),
  season_id: z.string(),
  crop_id: z.string(),
  varieties: z.array(z.string()),
  starts_at: z.string(),
  ends_at: z.string()
});

export const fieldWithCropzoneSchema = z.object({
  id: z.string(),
  name: z.string(),
  property_id: z.string(),
  parent_region_id: z.string(),
  geometry: z.unknown().nullable().optional(),
  declared_area: z.number(),
  calculated_area: z.number(),
  updated_at: z.string(),
  valid_since: z.string().nullable(),
  valid_until: z.string().nullable(),
  archived: z.boolean(),
  json_extended_attributes: z.record(z.string(), z.unknown()).nullable(),
  tags: z.array(z.string()),
  deleted: z.boolean(),
  cropzone: fieldCropzoneSchema.nullable()
});

export const fieldWithCropzonePageableSchema = z.object({
  content: z.array(fieldWithCropzoneSchema),
  total_elements: z.number(),
  total_pages: z.number(),
  last: z.boolean(),
  first: z.boolean(),
  size: z.number(),
  number: z.number(),
  number_of_elements: z.number(),
  empty: z.boolean()
});

export const fieldsBySeasonsSyncResponseSchema = fieldWithCropzonePageableSchema.extend({
  field_ids: z.array(z.string())
});
